module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/stream-browserify/~/readable-stream/passthrough.js
// module id = 722
// module chunks = 0